import { Navigate } from "react-router-dom";


const AuthenticatedRoute = ({ children, isAuthenticated }) => {

	const backUrl = localStorage.getItem("backUrl");

    if (isAuthenticated) {
    	if (backUrl) {
    		localStorage.removeItem("backUrl");
      		return <Navigate to={backUrl} replace />;
    	}
    	else
        	return <Navigate to="/profile" replace />;
    }

    return children;
}

export default AuthenticatedRoute;
